import { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";
import { Pause, Play } from "lucide-react";
import "./PumaFamilyHero.css";

const ASSETS = "/images/puma-family-2026/hero/";
/** Shared campaign creative. active lets a parent carousel suspend an off-screen slide. */
export default function PumaFamilyHero({
  active = true,
  variant = "landing",
  ctaHref = "#poiskayOferta",
  ctaLabel = "Поискай оферта",
}) {
  const root = useRef(null);
  const reducedMotion = useReducedMotion();
  const [paused, setPaused] = useState(false);
  const [visible, setVisible] = useState(false);
  const [pageVisible, setPageVisible] = useState(!document.hidden);
  const running = active && visible && pageVisible && !paused;
  const Heading = variant === "landing" ? "h1" : "h2";
  const interactive = active && (variant !== "carousel" || visible);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), { threshold: 0.15 });
    observer.observe(root.current);
    const visibility = () => setPageVisible(!document.hidden);
    document.addEventListener("visibilitychange", visibility);
    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", visibility);
    };
  }, []);

  const followOffer = (event) => {
    if (!ctaHref.startsWith("#")) return;
    const target = document.getElementById(ctaHref.slice(1));
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
    }
  };

  return (
    <section ref={root} className={`puma-animated-hero puma-animated-hero--${variant}`}
      aria-label="Избери своя Ford Puma" aria-hidden={!interactive}
      data-running={running && !reducedMotion}>
      <div className="puma-animated-hero__art" aria-hidden="true">
        <img className="puma-animated-hero__wide" src={`${ASSETS}family-wide.jpg`} alt="" fetchpriority="high" />
        <img className="puma-animated-hero__mobile" src={`${ASSETS}family.jpg`} alt="" />
      </div>
      <div className="puma-animated-hero__shade" />
      <div className="puma-animated-hero__content">
        <p className="puma-animated-hero__eyebrow">FORD PUMA / PUMA GEN-E</p>
        <div className="puma-animated-hero__headline-space">
          <Heading className="puma-animated-hero__headline">Избери своя Ford Puma</Heading>
        </div>
        <p className="puma-animated-hero__offer">
          Сега на <strong>СПЕЦИАЛНА<sup>*</sup> цена</strong><br />
          и с първоначален разход<br />от <strong className="puma-animated-hero__price">1 920 €<sup>**</sup></strong>
        </p>
        <a className="puma-animated-hero__cta" href={ctaHref} onClick={followOffer} tabIndex={interactive ? 0 : -1}>{ctaLabel}</a>
      </div>
      {!reducedMotion && <button type="button" className="puma-animated-hero__pause"
        aria-label={paused ? "Продължи анимацията" : "Спри анимацията"}
        tabIndex={interactive ? 0 : -1} onClick={() => setPaused(!paused)}>
        {paused ? <Play size={18} aria-hidden="true" /> : <Pause size={18} aria-hidden="true" />}
      </button>}
    </section>
  );
}
